import axios from 'axios';

const API_BASE_URL = 'https://ptsspl.in/public/api';

export interface TimeEntry {
  id: number;
  user_id: number;
  start_time: string;
  end_time: string;
  break_time: number;
  status: string;
  created_at: string;
  updated_at: string;
}

class TimeEntryService {
  async getAll(): Promise<TimeEntry[]> {
    try {
      const response = await axios.get(`${API_BASE_URL}/time-entries`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch time entries');
    }
  }

  async getById(id: number): Promise<TimeEntry> {
    try {
      const response = await axios.get(`${API_BASE_URL}/time-entries/${id}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch time entry');
    }
  }

  async create(entryData: Omit<TimeEntry, 'id' | 'created_at' | 'updated_at'>): Promise<TimeEntry> {
    try {
      const response = await axios.post(`${API_BASE_URL}/time-entries`, entryData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to create time entry');
    }
  }

  async update(id: number, entryData: Partial<Omit<TimeEntry, 'id' | 'created_at' | 'updated_at'>>): Promise<TimeEntry> {
    try {
      const response = await axios.put(`${API_BASE_URL}/time-entries/${id}`, entryData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update time entry');
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/time-entries/${id}`);
    } catch (error) {
      throw new Error('Failed to delete time entry');
    }
  }
}

const timeEntryService = new TimeEntryService();
export default timeEntryService;